export default __webpack_public_path__ + "static/media/Eldritch Gem.59fced85.jpg";